import { ErrorIcon, TrashIcon } from "assets";
import { CustomButton } from "components";

interface ConfirmationDialogProps {
  message: string;
  error?: string | null;
  onConfirm: React.MouseEventHandler<HTMLButtonElement> | undefined;
  onCancel: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  subTitle?: string;
  isErrorIcon?: boolean;
  imageUrl?: string;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  message,
  title,
  subTitle,
  error,
  onConfirm,
  onCancel,
  isErrorIcon,
  imageUrl
}) => {
  console.log("imageUrl", imageUrl);
  return (
    <>
      <div className="w-full text-center">
        <div className="w-full flex justify-center">
          <p className="w-fit flex justify-center rounded-lg p-2  ">
            {isErrorIcon ? (
              <ErrorIcon className="size-10 text-red-500 " />
            ) : (
              <TrashIcon className="size-10 text-red-500 " />
            )}
          </p>
        </div>
        {imageUrl ? (<div className="w-full flex justify-center">
          <img src={imageUrl} alt="icon" className="h-auto max-w-32 rounded-full"/>
        </div>) : null}
        <h2 className={`text-2xl font-semibold ${subTitle?"":"mb-4"}`}>{title}</h2>
        <h4 className="text text-primary-400  font-normal mb-4">{subTitle}</h4>
        <p className="text-gray-700 mb-6 text-lg">{message}</p>
        {error && <span className="text-sm text-red-600">{error}</span>}
      </div>
      <div className="flex justify-between gap-4 mt-4 px-6">
        <CustomButton
          type="button"
          onClick={() => onCancel(false)}
          className="bg-primary-500 text-white hover:bg-primary-900 hover:shadow-lg hover:scale-105 transition-all duration-300 ease-in-out transform"
        >
          Cancel
        </CustomButton>
        <CustomButton
          type="button"
          onClick={onConfirm}
          className="bg-red-500 text-white hover:bg-red-900 hover:shadow-lg hover:scale-105 transition-all duration-300 ease-in-out transform"
        >
          Confirm
        </CustomButton>
      </div>
    </>
  );
};

export default ConfirmationDialog;
